import * as React from "react";

import styled from "@emotion/styled";
import { Heading, HeadingType } from "./heading";
import { Step, StepProps } from "../services/step";

const StyledHeadingWithStep = styled(Heading)`
  display: flex;
  align-items: center;
  margin-bottom: var(--macro);
`;

export const HeadingWithStep = ({
  type,
  step,
  className,
  children,
}: {
  type: HeadingType;
  step: StepProps;
  className?: string;
  children: JSX.Element | JSX.Element[] | string;
}) => (
  <StyledHeadingWithStep type={type} className={className}>
    <>
      <Step src={step.src} alt={step.alt} />
      {children}
    </>
  </StyledHeadingWithStep>
);
